module.exports = __webpack_public_path__ + "media/images/admin/icons/flag-661b73f210343a267921723a8ac31b8e.svg";